import { Button, Modal } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { useRouter } from 'next/navigation';

export default function AcceptInviteModal({ isModalOpen, onClose }: { isModalOpen: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Modal
      open={isModalOpen}
      footer={null}
      className="max-w-[436px] rounded-3xl overflow-hidden p-0"
      onCancel={onClose}
      maskClosable={false}
      destroyOnHidden
    >
      <div className="w-full">
        <div className="relative px-[10%] w-[120%] bg-gradient-to-br from-[#FFE9A1] to-75% to-[#E1F4E1] -left-[10%] top-0 rounded-b-[50%] overflow-hidden">
          <div className="flex flex-col items-center w-full px-8 max-md:px-4">
            <div className="pt-5">
              <Image src="/images/referral/invite-success.png" alt="invite-success" width={400} height={400} />
            </div>
          </div>
        </div>
        <div className="px-8 max-md:px-4 pt-4 pb-8 flex flex-col items-center">
          <div className="text-2xl font-bold primary-text">{t("You've got the coupon!")}</div>
          <div
            className="primary-text-60 pt-5"
            dangerouslySetInnerHTML={{
              __html: t(
                `Buy any plan now and get <span class="font-bold text-[#725CFF]">+30 extra days</span> instantly. Check out Recent Follows Tool and more.`
              ),
            }}
          />
          <Button
            type="primary"
            shape="round"
            className="mt-10 h-14 w-full text-lg"
            href="/instagram-new-follow-tracker"
            onClick={(e) => {
              e.preventDefault();
              ga_logEvent(EventName.referral_claim_to_rf_click);
              setTimeout(router.push, 30, '/instagram-new-follow-tracker');
            }}
          >
            {t('🚀 Try It Now')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
